import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-statconnection-hp',
  templateUrl: './statconnection-hp.component.html',
  styleUrls: ['./statconnection-hp.component.css']
})
export class StatconnectionHPComponent implements OnInit {

  cohorte: any = null;
  breadcrumbItems!: BreadcrumbItem[];

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.cohorte = this.route.snapshot.params['cohortId'];
    this.breadcrumbItems = [
      { label: 'SIGUI' },
      {
        label: `SESSION ${this.cohorte}`,
        url: `/dashboard/appels/candidaturesHS/${this.cohorte}`,
      },
      {
        label: "STATISTIQUES DE CONNECTION",
        url: `/dashboard/appels/statconnectionHP/${this.cohorte}`,
      },
    ];
  }

}
